import { ArrowUpRight } from "lucide-react";

export const Marquee = ({ text = "OWN YOUR TURNING POINT", className = "" }) => (
  <div className={`select-none overflow-hidden whitespace-nowrap py-8 ${className}`} aria-hidden="true">
    <div className="marquee-track inline-flex items-center">
      {[0, 1].map((k) => (
        <span key={k} className="inline-flex items-center">
          {Array.from({ length: 5 }).map((_, i) => (
            <span key={i} className="mx-10 inline-flex items-center gap-10">
              <span className="text-outline font-serif text-6xl md:text-8xl">{text}</span>
              <ArrowUpRight className="h-10 w-10 text-teal/60" strokeWidth={1.5} />
            </span>
          ))}
        </span>
      ))}
    </div>
  </div>
);
